/**
 * @generated SignedSource<<e73b72bf39f3b51f17ce7a1dd213708e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentsDemonstratedSkillsReportFilterInput = {
  studentIds?: ReadonlyArray<string> | null | undefined;
};
export type DiagnosticsDemonstratedSkillsQuery$variables = {
  filter: StudentsDemonstratedSkillsReportFilterInput;
};
export type DiagnosticsDemonstratedSkillsQuery$data = {
  readonly studentsDemonstratedSkillsReport: ReadonlyArray<{
    readonly demonstratedSkills: number;
    readonly studentId: string;
  }>;
};
export type DiagnosticsDemonstratedSkillsQuery = {
  response: DiagnosticsDemonstratedSkillsQuery$data;
  variables: DiagnosticsDemonstratedSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "StudentDemonstratedSkillsReport",
    "kind": "LinkedField",
    "name": "studentsDemonstratedSkillsReport",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "demonstratedSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "studentId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiagnosticsDemonstratedSkillsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiagnosticsDemonstratedSkillsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "14453800154d6bef6b67c545bb60d116",
    "id": null,
    "metadata": {},
    "name": "DiagnosticsDemonstratedSkillsQuery",
    "operationKind": "query",
    "text": "query DiagnosticsDemonstratedSkillsQuery(\n  $filter: StudentsDemonstratedSkillsReportFilterInput!\n) {\n  studentsDemonstratedSkillsReport(filter: $filter) {\n    demonstratedSkills\n    studentId\n  }\n}\n"
  }
};
})();

(node as any).hash = "e63fe41057358f61ca42c27541ad98f9";

export default node;
